import { REGULATIONS_DIALOG, UKGC_DIALOG } from '@lobby/components/Dialog/constants';
import { notificationTypes, ukgcNotifications } from '@lobby/store/constants/regulations';
import { dialog } from '@lobby/store/dialog';

export const handlePlayerNotifications = (data) => {
  const { type } = data;
  const actions = [];

  if (ukgcNotifications.includes(type)) {
    actions.push(dialog.open({
      name: UKGC_DIALOG,
      data,
    }),);
    return actions;
  }

  if (notificationTypes.includes(type)) {
    actions.push(dialog.open({ name: REGULATIONS_DIALOG, data }));
    return actions;
  }

  return actions;
};
